import { MapPin } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export type FeedFilterType = 'all' | 'following' | 'mine' | 'local';

interface FeedFiltersProps {
  activeFilter: FeedFilterType;
  onFilterChange: (filter: FeedFilterType) => void;
  hasLocation?: boolean;
}

export const FeedFilters = ({ activeFilter, onFilterChange, hasLocation = false }: FeedFiltersProps) => {
  const filters = [
    { value: 'all' as const, label: 'All' },
    { value: 'following' as const, label: 'Following' },
    { value: 'mine' as const, label: 'Mine' },
    { value: 'local' as const, label: 'Local', icon: MapPin, requiresLocation: true },
  ];

  return (
    <TooltipProvider>
      <div className="flex items-center gap-1 border-b border-border">
        {filters.map((filter) => {
          const isDisabled = filter.requiresLocation && !hasLocation;
          const Icon = filter.icon;
          
          const button = (
            <button
              key={filter.value}
              onClick={() => !isDisabled && onFilterChange(filter.value)}
              disabled={isDisabled}
              className={`relative px-4 py-2.5 text-sm transition-colors ${
                activeFilter === filter.value
                  ? 'text-foreground font-semibold'
                  : 'text-muted-foreground hover:text-foreground font-medium'
              } ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              <span className="flex items-center gap-1.5">
                {Icon && <Icon className="h-3.5 w-3.5" />}
                {filter.label}
              </span>
              {activeFilter === filter.value && (
                <span className="absolute bottom-0 left-2 right-2 h-0.5 bg-primary rounded-full" />
              )}
            </button>
          );

          if (isDisabled) {
            return (
              <Tooltip key={filter.value}>
                <TooltipTrigger asChild>
                  {button}
                </TooltipTrigger>
                <TooltipContent>
                  <p>Set your home location in Settings to use this filter</p>
                </TooltipContent>
              </Tooltip>
            );
          }

          return button;
        })}
      </div>
    </TooltipProvider>
  );
};
